exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ScoringSummary__header--1Qz0M {\n  display: flex;\n  justify-content: space-between;\n}\n\nh2 {\n  padding-left: 8px;\n  padding-bottom: 8px;\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.ScoringSummary__period--1F85D {\n  padding-bottom: 10px;\n}\n\n.ScoringSummary__periodTitle--38wSp {\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.ScoringSummary__scoringCard--WWGKD {\n  border-top: 1px solid #1e1f21;\n  padding: 0 10px;\n}\n\n.ScoringSummary__noScoringCard--8A56S {\n  font-weight: 400;\n  padding: 10px;\n}\n\n.ScoringSummary__scoringCard--WWGKD:nth-child(2) {\n  border-top: 0;\n}\n\n@media (min-width: 992px) {\n  .ScoringSummary__scoringCard--WWGKD {\n    padding: 0 0 0 10px;\n  }\n}", ""]);

// exports
exports.locals = {
	"header": "ScoringSummary__header--1Qz0M",
	"period": "ScoringSummary__period--1F85D",
	"periodTitle": "ScoringSummary__periodTitle--38wSp",
	"scoringCard": "ScoringSummary__scoringCard--WWGKD",
	"noScoringCard": "ScoringSummary__noScoringCard--8A56S"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };